module.exports = __webpack_public_path__ + "img/118.00b02ffd.jpg";